import React, { ReactEventHandler, SyntheticEvent, useCallback, useEffect, useState } from 'react';

import { IImgPlaceholder } from '../img-placeholder/img-placeholder';

export interface IAvatarPlaceholder extends IImgPlaceholder {
  images: string[];
  size?: number;
}

const AvatarPlaceholder = ({ images, placeholder, size, ...props }: IAvatarPlaceholder) => {
  const [image, setImage] = useState<string | null>(null);
  const [imageIndex, setImageIndex] = useState<number>(0);

  const onError: ReactEventHandler<HTMLImageElement> = useCallback(
    (evt: SyntheticEvent<HTMLImageElement, Event>) => {
      if (images?.length && imageIndex < images.length - 1) {
        setImageIndex((prev) => prev + 1);
      } else {
        setImage(setImageSize({ img: placeholder }));
      }
    },
    [placeholder, images, imageIndex]
  );

  const setImageSize = (params: { img: string; size?: number }) => {
    const { img, size } = params;

    if (size) {
      return `${img}?im=Resize,width=${size}`;
    }

    return img;
  };

  useEffect(() => {
    setImage(setImageSize({ img: images[imageIndex], size }));
  }, [images, size, imageIndex]);

  useEffect(() => {
    setImageIndex(0);
  }, [images]);

  return image ? <img src={image} onError={onError} {...props} /> : <img src={placeholder} {...props} />;

  //
};

export default AvatarPlaceholder;
